import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../services/api';

// Eén regel bovenin voor een ongelezen uitgelicht bericht; weg na klikken/sluiten (POST /nieuws/gezien)
export default function NieuwsBanner() {
  const nav = useNavigate();
  const loc = useLocation();
  const [b, setB] = useState(null);
  useEffect(() => { api.get('/nieuws/ongelezen').then((r) => setB(r.data.banner || null)).catch(() => {}); }, [loc.pathname.startsWith('/nieuw')]); // eslint-disable-line
  if (!b || loc.pathname.startsWith('/nieuw') || loc.pathname.startsWith('/admin')) return null;
  const weg = () => { setB(null); api.post('/nieuws/gezien').catch(() => {}); };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#0f172a', color: '#fff', padding: '10px 18px', borderRadius: 10, margin: '0 0 16px', fontSize: 14 }}>
      <span style={{ background: '#00D4AA', color: '#0f172a', fontSize: 11, fontWeight: 800, padding: '2px 8px', borderRadius: 6, letterSpacing: 1 }}>NIEUW</span>
      <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{b.titel}</span>
      <button onClick={() => { weg(); nav(`/nieuw/${b.id}`); }} style={{ background: '#fff', color: '#0f172a', border: 'none', borderRadius: 8, padding: '6px 14px', fontWeight: 600, cursor: 'pointer' }}>Lees →</button>
      <button onClick={weg} title="Sluiten" style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
    </div>
  );
}
